import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ofType } from "redux-observable";
import { map } from "rxjs";
import { uploadFileActions } from "./uploadFiles/uploadFileSlice";

interface ModalState {
  jobsModalVisible: boolean;
  logModalVisible: boolean;
  tableConfigModalVisible: boolean;
  currentFileId: string | null; // Track which file's log modal is open
  currentFileName: string | null; // Track the actual filename for display
  addFilesModalVisible: boolean;
  addFolderModalVisible: boolean;
  renameModalVisible: boolean;
  renameFile: any | null;
  moveModalVisible: boolean;
  moveItems: Array<{ id: string; name: string; type: string }>;
  uploadFolderMode: boolean;
  fileVersionModalVisible: boolean;
  selectedFile: any | null;
}

const initialState: ModalState = {
  jobsModalVisible: false,
  logModalVisible: false,
  tableConfigModalVisible: false,
  currentFileId: null,
  currentFileName: null,
  addFilesModalVisible: false,
  addFolderModalVisible: false,
  renameModalVisible: false,
  renameFile: null,
  moveModalVisible: false,
  moveItems: [],
  uploadFolderMode: false,
  fileVersionModalVisible: false,
  selectedFile: null,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openRenameModal(state, action: PayloadAction<{ file: any }>) {
      state.renameModalVisible = true;
      state.renameFile = action.payload.file;
    },
    closeRenameModal(state) {
      state.renameModalVisible = false;
      state.renameFile = null;
    },
    openJobsModal(state) {
      state.jobsModalVisible = true;
    },
    closeJobsModal(state) {
      state.jobsModalVisible = false;
    },
    openLogModal(
      state,
      action: PayloadAction<{ fileId: string; fileName?: string }>
    ) {
      state.logModalVisible = true;
      state.currentFileId = action.payload.fileId;
      state.currentFileName =
        action.payload.fileName || `File ${action.payload.fileId}`;
    },
    closeLogModal(state) {
      state.logModalVisible = false;
      state.currentFileId = null;
      state.currentFileName = null;
    },
    openAddFilesModal(state) {
      state.addFilesModalVisible = true;
    },
    closeAddFilesModal(state) {
      state.addFilesModalVisible = false;
    },
    openAddFolderModal(state) {
      state.addFolderModalVisible = true;
    },
    closeAddFolderModal(state) {
      state.addFolderModalVisible = false;
    },
    openMoveModal(
      state,
      action: PayloadAction<{
        items: any[];
      }>
    ) {
      state.moveModalVisible = true;
      state.moveItems = action.payload.items;
    },
    closeMoveModal(state) {
      state.moveModalVisible = false;
      state.moveItems = [];
    },
    openFileVersionModal(state, action: PayloadAction<{ file: any }>) {
      state.fileVersionModalVisible = true;
      state.selectedFile = action.payload.file;
    },
    closeFileVersionModal(state) {
      state.fileVersionModalVisible = false;
      state.selectedFile = null;
    },
    setUploadFolderMode(state, action: PayloadAction<boolean>) {
      state.uploadFolderMode = action.payload;
    },
    // openTableConfigModal(state) {
    //   state.tableConfigModalVisible = true;
    // },
    // closeTableConfigModal(state) {
    //   state.tableConfigModalVisible = false;
    // },
  },
});

export const closeJobsModalEpic = (action$: any) =>
  action$.pipe(
    ofType(modalActions.closeJobsModal.type),
    map(() => uploadFileActions.removePendingStatuses())
  );

export const modalActions = modalSlice.actions;
export const modalEpics = [closeJobsModalEpic];

export default modalSlice.reducer;
